import { Link } from "react-router-dom";
import { LogoMark } from "./Logo";

export default function Footer() {
  return (
    <footer className="relative border-t border-[var(--line)] px-5 sm:px-8 lg:px-12 pt-20 pb-36 overflow-hidden" data-testid="site-footer">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <LogoMark size={44} />
          <p className="f-serif italic text-2xl mt-6 max-w-sm leading-snug text-[var(--bone)]">If it resonates, stay. If not, move on.</p>
        </div>
        <nav className="md:col-span-3 flex flex-col gap-3" aria-label="Footer">
          <span className="eyebrow mb-2">Index</span>
          {[["/explore", "Explore"], ["/listen", "Listen"], ["/fragments", "Fragments"], ["/subscribe", "Subscribe"]].map(([to, l]) => (
            <Link key={to} to={to} className="f-display font-bold uppercase text-2xl w-fit link-u" data-testid={`footer-${l.toLowerCase()}-link`}>{l}</Link>
          ))}
        </nav>
        <div className="md:col-span-4 flex flex-col gap-2 f-mono text-xs text-[var(--ash)]">
          <span className="eyebrow mb-2">Coordinates</span>
          <span>x: moral geometry</span>
          <span>y: myth-tech</span>
          <span>z: the long, hard home</span>
          <a href="https://www.outlawcreative.ink" className="mt-4 link-u w-fit text-[var(--bone)]" data-testid="footer-archive-link">outlawcreative.ink archive</a>
        </div>
      </div>
      <p className="f-display font-black uppercase leading-[0.8] mt-20 text-[22vw] md:text-[17vw] tracking-tight text-[var(--bone)] select-none" aria-hidden="true">Outlaw</p>
      <div className="flex flex-col sm:flex-row justify-between gap-2 mt-6 f-mono text-xs text-[var(--ash)]">
        <span>&copy; 2026 Outlaw Creative</span>
        <span>(the geometry of life)</span>
      </div>
    </footer>
  );
}
